import React from 'react';
import StrategyCard from './StrategyCard';
import { StrategyItem } from './types';

interface StrategySectionProps {
  title: string;
  description: string;
  buttonLabel: string;
  strategies: StrategyItem[];
  onViewAll?: () => void;
}

const StrategySection: React.FC<StrategySectionProps> = ({
  title,
  description,
  buttonLabel,
  strategies,
  onViewAll,
}) => {
  if (strategies.length === 0) return null;

  return (
    <div className="mb-12">
      {/* Section Header */}
      <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-6 gap-4">
        <div>
          <h2 className="text-2xl font-bold flex items-center text-gray-900">{title}</h2>
          <p className="text-gray-500 text-sm mt-1">{description}</p>
        </div>
        <div className="flex items-center space-x-3">
          <button
            onClick={onViewAll}
            className="px-5 py-2 rounded-full border border-gray-300 bg-white text-sm font-medium hover:bg-gray-100 transition-colors text-gray-800 shadow-sm"
          >
            {buttonLabel}
          </button>
        </div>
      </div>

      {/* Grid of Strategy Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {strategies.map((item) => (
          <StrategyCard key={item.id} strategy={item} />
        ))}
      </div>
    </div>
  );
};

export default StrategySection;
